import { observer } from "mobx-react-lite";
import { useParams } from "@tanstack/react-router";

import { ImportApplicationModal } from "../../../components/import-application";
import { usePageStore } from "../application-detail-page.lib";

export const ApplicationDetailImportModal = observer(() => {
  const store = usePageStore();
  const { id } = useParams({ from: "/applications/$id" });

  return (
    <ImportApplicationModal
      isOpen={store.popupAction?.type === "import-application"}
      requestId={id}
      onOpenChange={(open) => {
        if (!open) {
          store.setPopupAction(null);
        }
      }}
    />
  );
});
